module.exports = __webpack_public_path__ + "static/media/rack-and-pinion-red.8810f302.svg";